import { makeStyles, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { changePageTitle } from '../../actions'


const NotFound: React.FC = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(changePageTitle('404'))
    })


    return (
        <div>
            <Typography>Page Not Found</Typography>
        </div>
    )
}

export default NotFound
